module.exports = __webpack_public_path__ + "img/about.065b869a.png";